import { render } from "./Flag.vue?vue&type=template&id=618d56b3&ts=true"
import script from "./Flag.vue?vue&type=script&lang=ts"
export * from "./Flag.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__